import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'

Vue.use(Router)

export default new Router({
  mode: 'history', // 访问路径不带井号  需要使用 history模式
  base: '/obia', // 基础路径
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: {name: 'Home'}
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/browse',
      name: 'Browse',
      component: resolve => require(['@/views/Browse'], resolve)
    },
    {
      path: '/search-image',
      name: 'SearchImage',
      component: resolve => require(['@/views/SearchImage'], resolve)
    },
    {
      path: '/thumbnail-viewer',
      name: 'ThumbnailViewer',
      component: resolve => require(['@/views/ThumbnailViewer'], resolve)
    },
    {
      path: '/statistics',
      name: 'Statistics',
      component: resolve => require(['@/views/Statistics'], resolve)
    },
    {
      path: '/collection/:collectionAccession',
      name: 'Collection',
      component: resolve => require(['@/views/Collection'], resolve)
    },
    {
      path: '/individual/:individualAccession',
      name: 'Individual',
      component: resolve => require(['@/views/Individual'], resolve)
    },
    {
      path: '/preview/:collectionAccession/:randomCode',
      name: 'Preview',
      component: resolve => require(['@/views/Preview'], resolve)
    },
    // -------------------- submit ------------------------------
    {
      path: '/submit',
      name: 'Submit',
      component: resolve => require(['@/views/submit/Submit'], resolve)
    },
    {
      path: '/submit/new',
      name: 'SubmitNew',
      meta: {
        requireAuth: true
      },
      component: resolve => require(['@/views/submit/SubmitNew'], resolve)
    },
    {
      path: '/submit/my-submissions',
      name: 'SubmitView',
      meta: {
        requireAuth: true
      },
      component: resolve => require(['@/views/submit/SubmitView'], resolve)
    },
    {
      path: '/submit/:submitCode',
      name: 'SubmitDetail',
      meta: {
        requireAuth: true
      },
      component: resolve => require(['@/views/submit/SubmitDetail'], resolve)
    },
    {
      path: '/submit/:submitCode/edit',
      name: 'SubmitEdit',
      meta: {
        requireAuth: true
      },
      component: resolve => require(['@/views/submit/SubmitEdit'], resolve)
    },
    // -------------------- request ------------------------------
    {
      path: '/request',
      name: 'Request',
      component: resolve => require(['@/views/request/Request'], resolve)
    },
    {
      path: '/request/my-requests',
      name: 'RequestView',
      // 添加该字段，表示进入这个路由是需要登录的
      meta: {
        requireAuth: true
      },
      component: resolve => require(['@/views/request/RequestView'], resolve)
    },
    // {
    //   path: '/submit-requests',
    //   name: 'RequestSubmit',
    //   meta: {
    //     requireAuth: true
    //   },
    //   component: resolve => require(['@/views/request/RequestSubmit'], resolve)
    // },
    // {
    //   path: '/receive-requests',
    //   name: 'RequestReceive',
    //   meta: {
    //     requireAuth: true
    //   },
    //   component: resolve => require(['@/views/request/RequestReceive'], resolve)
    // },
    {
      path: '/request/new',
      name: 'RequestNew',
      meta: {
        requireAuth: true
      },
      component: resolve => require(['@/views/request/RequestNew'], resolve)
    },
    {
      path: '/request/:requestCode',
      name: 'RequestDetail',
      meta: {
        requireAuth: true
      },
      component: resolve => require(['@/views/request/RequestDetail'], resolve)
    },
    {
      path: '/request/:requestCode/edit',
      name: 'RequestEdit',
      meta: {
        requireAuth: true
      },
      component: resolve => require(['@/views/request/RequestEdit'], resolve)
    },
    {
      path: '/de-identification',
      name: 'DeIdentificaion',
      component: resolve => require(['@/views/documentation/DeIdentification'], resolve)
    },
    {
      path: '/obia',
      name: 'Obia',
      component: resolve => require(['@/views/documentation/Obia'], resolve)
    },
    {
      path: '/tutorial',
      name: 'Tutorial',
      component: resolve => require(['@/views/documentation/Tutorial'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js